export default "__VITE_ASSET__CRSAAjNF__"